import script from "./AppHeaderSettingsConfigs.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderSettingsConfigs.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderSettingsConfigs.vue?vue&type=style&index=0&id=1a6f7d90&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6f7d90"]])

export default __exports__